import { FC } from 'react';

import { Box } from '@mui/material';

import { CurrencyLabelComponent } from './CurrencyLabelComponent';

export const Currency: FC = () => {
  return (
    <Box sx={{ marginBottom: '16px' }}>
      <CurrencyLabelComponent />
    </Box>
  );
};
